import React from "react";
import newImg from "../../assets/images/common/new_img.png";

const NewImage: React.FC = ({}) => {
  return (
    <img
      src={newImg} // Replace with your image source
      alt="new"
      style={{
        width: "30px",
        height: "20px",
        marginLeft: "8px",
      }}
    />
  );
};

export default NewImage;
